import React from 'react';
import { Grid, Typography, Box, Divider, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import pkg from '../../../../package.json';

import FooterMainLogo from './FooterMainLogo';
import FooterExternalLogos from './FooterExternalLogos';
import FooterRightLinks from './FooterRightLinks';

import { sxStyle } from './styles';

import Legals from './Legals';

const Footer = () => {
  const pageConfiguration = useSelector(store => store.pageConfiguration);
  const theme = useTheme();

  const getRange = () => {
    const currentDate = new Date();
    const futureDate = new Date(currentDate);
    futureDate.setDate(currentDate.getDate() + 2);
    return `${formatDate(currentDate)} al ${formatDate(futureDate)}`;
  };

  const formatDate = date => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  let copyrights = pageConfiguration.copyrights;
  copyrights = copyrights
    .replace('[tag_año_actual]', new Date().getFullYear())
    .replace('[tag_fecha_vigencia]', getRange());

  return (
    <Box
      component="footer"
      data-testid="footer"
      className="minWebPadding"
      sx={{ ...sxStyle.containerFooter, backgroundColor: theme.footerColor }}
    >
      {/* ── Fila principal: Logo | Logos externos | AFIP + Redes ── */}
      <Grid
        container
        alignItems="center"
        sx={{ pt: { xs: 3, md: 4 }, pb: { xs: 2, md: 3 } }}
      >
        <FooterMainLogo pageConfiguration={pageConfiguration} theme={theme} />
        <FooterExternalLogos copyrights={copyrights} />
        <FooterRightLinks pageConfiguration={pageConfiguration} theme={theme} />
      </Grid>

      {/* ── Divisor ── */}
      <Divider sx={{ borderColor: 'rgba(255,255,255,0.15)' }} />

      {/* ── Links legales + Versión ── */}
      <Grid container>
        {pageConfiguration.legals && <Legals />}
        <Grid item xs={12} sx={{ pb: 1.5 }}>
          <Typography
            align="center"
            sx={{ color: 'rgba(255,255,255,0.3)', fontSize: '10px' }}
          >
            Versión: {pkg.version}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
